import './scss/style.scss';
import "@coreui/chartjs/scss/coreui-chartjs.scss";

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import React, { useEffect } from 'react';
import userManager, { loadUserFromStorage } from './services/userService';

import AuthProvider from './utils/authProvider';
import PrivateRoute from './utils/protectedRoute';
import SigninOidc from './views/pages/signin-oidc';
import SignoutOidc from './views/pages/signout-oidc';
import store from './store';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))

const App = () => {
  useEffect(() => {
    // fetch current user from cookies
    loadUserFromStorage(store)
  }, []);

    return (
        <AuthProvider userManager={userManager} store={store}>
          <BrowserRouter>
            <React.Suspense fallback={loading}>
              <Switch>
                <Route exact path="/login" component={Login} /> 
                <Route exact path="/signout-oidc" component={SignoutOidc} />
                <Route exact path="/signin-oidc" component={SigninOidc} />
                <PrivateRoute path="*" name="WorkOrders" render={(props) => <DefaultLayout {...props} />} />
              </Switch>
            </React.Suspense>
          </BrowserRouter>
        </AuthProvider>
    )
}

export default App